import React from 'react';
import '../styles/passionateteam.css';
import colleaguesDiscussing from '../../../../assets/company/aboutus/colleagues_discussing.jpg';
import teamDiscuss from '../../../../assets/company/aboutus/team_discuss.jpg';
import groupDiscuss from '../../../../assets/company/aboutus/group_discuss.jpg';

const PassionateTeam = () => {
    return (
        <section className="passionate-team-section">
            <div className="passionate-team-container">
                <div className="passionate-team-images">
                    <div className="passionate-team-image">
                        <img
                            src={colleaguesDiscussing}
                            alt="Colleagues discussing"
                            className="passionate-team-img"
                        />
                    </div>
                    <div className="passionate-team-image">
                        <img
                            src={teamDiscuss}
                            alt="Team discussion"
                            className="passionate-team-img"
                        />
                    </div>
                    <div className="passionate-team-image">
                        <img
                            src={groupDiscuss}
                            alt="Group discussion"
                            className="passionate-team-img"
                        />
                    </div>
                </div>
                <div className="passionate-team-content">
                    <h2 className="passionate-team-title">
                        Who We Are
                    </h2>
                    <p className="passionate-team-description">
                        Synectiks is a trusted leader in endpoint management, cloud infrastructure, backup and disaster recovery, secure cloud hosting, application modernization, and Microsoft-powered workplace transformation
                        As a certified Microsoft Solutions Partner, we bring proven expertise across Microsoft 365, Copilot readiness, identity security, and compliance-aligned architectures.
                        We combine deep technical knowledge with an agile, efficient, and highly responsive team focused on customer success.
                        With Synectiks, businesses avoid vendor lock-in, reduce operational complexity, strengthen cyber resilience, and achieve faster time-to-value through secure and scalable transformation.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default PassionateTeam;
